import { combineReducers } from 'redux';
import appReducer from './appReducer';
import themeReducer from './themeReducer';
export default combineReducers({
  themePreviewApp: appReducer,
  theme: themeReducer
});